export default __webpack_public_path__ + "static/media/gold-6.e7ce8f32.png";